import { __extends } from "tslib";
import { MovieClip as AwayMovieClip, Sprite as AwaySprite, } from '@awayjs/scene';
import { DefaultSceneGraphFactory } from '@awayjs/scene';
import { Bitmap } from '../display/Bitmap';
import { BitmapData } from '../display/BitmapData';
import { Multiname, constructClassFromSymbol, ABCFile, } from '@awayfl/avm2';
var FlashSceneGraphFactory = /** @class */ (function (_super) {
    __extends(FlashSceneGraphFactory, _super);
    function FlashSceneGraphFactory(sec, loaderInfo) {
        var _this = _super.call(this) || this;
        _this.imageStore = {};
        _this._sec = sec;
        _this._loaderInfo = loaderInfo;
        return _this;
    }
    Object.defineProperty(FlashSceneGraphFactory.prototype, "appDomain", {
        get: function () {
            if (this._loaderInfo) {
                return this._loaderInfo.applicationDomain.axApplicationDomain;
            }
            return this._sec.application;
        },
        enumerable: true,
        configurable: true
    });
    FlashSceneGraphFactory.prototype.executeABCBytes = function (abcBlocks) {
        for (var i = 0; i < abcBlocks.length; i++) {
            var abcBlock = abcBlocks[i];
            var abc = new ABCFile({ app: this.appDomain, url: '' }, abcBlock.data);
            if (abcBlock.flags) {
                // kDoAbcLazyInitializeFlag = 1 Indicates that the ABC block should not be executed
                // immediately.
                this.appDomain.loadABC(abc);
            }
            else {
                // TODO: probably delay execution until playhead reaches the frame.
                this.appDomain.loadAndExecuteABC(abc);
            }
        }
        return null;
    };
    FlashSceneGraphFactory.prototype.createSprite = function (_prefab, graphics, symbol) {
        if (_prefab === void 0) { _prefab = null; }
        if (graphics === void 0) { graphics = null; }
        if (symbol === void 0) { symbol = null; }
        if (!symbol || !this._sec)
            throw ('no symbol provided');
        var symbolClass = null;
        if (symbol.className)
            symbolClass = this.appDomain.getClass(Multiname.FromFQNString(symbol.className, 0 /* Public */));
        else
            symbolClass = this._sec.flash.display.Sprite.axClass;
        symbol.symbolClass = symbolClass;
        //Graphicsadapter.currentAwayGraphics=graphics;
        // create the root for the root-symbol
        var asObj = constructClassFromSymbol(symbol, symbolClass);
        asObj.adaptee = new AwaySprite(graphics);
        // manually call the axInitializer for now:
        //asObj.axInitializer(AwaySprite.getNewSprite(new this._sec.flash.display.Graphics(graphics).adaptee));
        return asObj.adaptee;
    };
    FlashSceneGraphFactory.prototype.createDisplayObjectContainer = function (_symbol) {
        if (_symbol === void 0) { _symbol = null; }
        return new this._sec.flash.display.DisplayObjectContainer().adaptee;
    };
    FlashSceneGraphFactory.prototype.createBinarySymbol = function (symbol) {
        if (symbol === void 0) { symbol = null; }
        this.appDomain.addBinarySymbol(symbol);
    };
    FlashSceneGraphFactory.prototype.createMovieClip = function (_timeline, symbol) {
        if (_timeline === void 0) { _timeline = null; }
        if (symbol === void 0) { symbol = null; }
        if (!symbol || !this._sec)
            throw ('no symbol provided');
        var symbolClass = null;
        if (symbol.className) {
            symbolClass = this.appDomain.getClass(Multiname.FromFQNString(symbol.className, 0 /* Public */));
            symbolClass._symbol = symbol;
        }
        else {
            symbolClass = this._sec.flash.display.MovieClip.axClass;
        }
        //console.log("parsed symbolClass", symbolClass, symbol);
        symbol.symbolClass = symbolClass;
        // create the root for the root-symbol
        var asObj = constructClassFromSymbol(symbol, this._sec.flash.display.MovieClip.axClass);
        asObj.adaptee = new AwayMovieClip();
        symbol.timeline = asObj.adaptee.timeline;
        //(<AwayMovieClip>asObj.adaptee).timeline.resetScripts();
        //(<any>asObj).axInitializer();
        return asObj.adaptee;
    };
    FlashSceneGraphFactory.prototype.createTextField = function (symbol) {
        if (symbol === void 0) { symbol = null; }
        var symbolClass = null;
        if (symbol.className) {
            symbolClass = this.appDomain.getClass(Multiname.FromFQNString(symbol.className, 0 /* Public */));
        }
        else {
            symbolClass = this._sec.flash.text.TextField.axClass;
        }
        symbol.symbolClass = symbolClass;
        // create the root for the root-symbol
        var asObj = constructClassFromSymbol(symbol, symbolClass);
        // 	manually call the axInitializer - this will run the constructor
        //	creating new Away-MovieClip and timeline, and registers framescripts on the timeline:
        asObj.axInitializer();
        return asObj.adaptee;
    };
    FlashSceneGraphFactory.prototype.createBillboard = function (material, _symbol) {
        if (_symbol === void 0) { _symbol = null; }
        return new Bitmap(material.style.image.adapter).adaptee;
    };
    FlashSceneGraphFactory.prototype.createImage2D = function (width, height, transparent, fillColor, _powerOfTwo, _symbol) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = null; }
        if (_powerOfTwo === void 0) { _powerOfTwo = true; }
        if (_symbol === void 0) { _symbol = null; }
        var image = new BitmapData(width, height, transparent, fillColor).adaptee;
        // drop weak ref for symbols
        image.unuseWeakRef();
        return image;
    };
    FlashSceneGraphFactory.prototype.createFrameScripts = function (_scripts, _frameIdx, _objName, _objID) {
        console.warn('[FlashSceneGraphFactory] - createFrameScripts - should never be called');
        return null;
    };
    return FlashSceneGraphFactory;
}(DefaultSceneGraphFactory));
export { FlashSceneGraphFactory };
